
export class UiSettings {

    public repoName: string = '';
    public isAdmin: boolean = false;
    public showRegistrationPage: boolean = false;
    public showDbPage: boolean = false;
    public isLoaded: boolean = false;

    load(other: UiSettings) {
        this.repoName = other.repoName;
        this.isAdmin = other.isAdmin;
        this.showRegistrationPage = other.showRegistrationPage;
        this.showDbPage = other.showDbPage;
        this.isLoaded = true;
    }
}